// Timesheet API datetimes are shown using the date/time portion (slice 0,16)
// as local wall-clock time — same as datetime-local inputs on Edit Timesheet.

export const toTimesheetLocalInputValue = iso => {
  if (!iso) return '';
  return iso.slice(0, 16);
};

export const parseTimesheetLocalDate = iso => {
  if (!iso) return null;
  const date = new Date(iso.slice(0, 16));
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatTimesheetDateTimeDisplay = isoOrDate => {
  const date =
    isoOrDate instanceof Date
      ? isoOrDate
      : typeof isoOrDate === 'string'
        ? parseTimesheetLocalDate(isoOrDate)
        : null;

  if (!date) return '';

  const datePart = date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });

  const timePart = date.toLocaleTimeString('en-GB', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

  return `${datePart}, ${timePart}`;
};
